import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type QuizEditorPublishedQuestionFragment = { options?: Array<{ optionId: string, optionText: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null, correctOptions: Array<{ optionId: string }> };


export type QuizEditorPublishedQuestionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuizEditorQuestionFragment = { id: string, actualQuestionId?: string | null, questionText?: string | null, questionTextType?: Types.QuestionTextTypeEnum | null, questionType: Types.QuestionTypeEnum, subType?: Types.QuestionSubTypeEnum | null, isActive?: boolean | null, correctAnswerFeedback?: string | null, incorrectAnswerFeedback?: string | null, difficulty?: Types.DifficultyEnum | null, skillIds?: Array<string> | null, description?: string | null, subWorkspaces?: Array<string> | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, settings?: { shuffleOptions?: boolean | null, ratingScale?: number | null, enableDescription?: boolean | null, textLength?: Types.QuestionTextlengthEnum | null } | null, options?: Array<{ optionId: string, optionText: string, optionRelativeScore?: number | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null, correctOptions: Array<{ optionId: string }>, mtfComponent?: { leftElements: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }>, rightElements: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> } | null, ftbComponents: Array<{ text?: string | null, isBlank: boolean, id: string, distractors?: Array<{ id: string, text: string }> | null }>, imageHotspotComponents: Array<{ id: string, text?: string | null, mediaId: string, x: number, y: number }>, correctFTBAnswers: Array<{ text?: string | null, isBlank: boolean, id: string }>, correctImageHotspotAnswers: Array<{ id: string, text?: string | null, mediaId: string, x: number, y: number }>, globalDistractors?: Array<{ id: string, text: string }> | null, customRatingComponent?: { ratingLabels: Array<{ labelName: string, rating?: number | null }> } | null, publishedQuestion?: { options?: Array<{ optionId: string, optionText: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null, correctOptions: Array<{ optionId: string }> } | null };


export type QuizEditorQuestionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizEditorPublishedQuestionFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizEditorPublishedQuestion on QuestionType {
  options {
    optionId
    optionText
    attachments {
      ...EntityMedia
    }
  }
  correctOptions {
    optionId
  }
}
    `;
export const QuizEditorQuestionFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizEditorQuestion on QuestionType {
  id
  actualQuestionId
  questionText
  questionTextType
  questionType
  subType
  isActive
  correctAnswerFeedback
  incorrectAnswerFeedback
  difficulty
  skillIds
  description
  subWorkspaces
  attachments {
    ...EntityMedia
  }
  settings {
    shuffleOptions
    ratingScale
    enableDescription
    textLength
  }
  options {
    optionId
    optionText
    optionRelativeScore
    attachments {
      ...EntityMedia
    }
  }
  correctOptions {
    optionId
  }
  mtfComponent(shuffleMTFComponents: false) {
    leftElements {
      text
      id
      attachments {
        ...EntityMedia
      }
    }
    rightElements {
      text
      id
      attachments {
        ...EntityMedia
      }
    }
  }
  ftbComponents {
    text
    distractors {
      id
      text
    }
    isBlank
    id
  }
  imageHotspotComponents {
    id
    text
    mediaId
    x
    y
  }
  correctFTBAnswers {
    text
    isBlank
    id
  }
  correctImageHotspotAnswers {
    id
    text
    mediaId
    x
    y
  }
  globalDistractors {
    id
    text
  }
  customRatingComponent {
    ratingLabels {
      labelName
      rating
    }
  }
  publishedQuestion {
    ...QuizEditorPublishedQuestion
  }
}
    `;